import { atom } from 'jotai';

export const lcpCompleteAtom = atom(false);
export const fcpCompleteAtom = atom(false);
